<template>
    <div>
        <b-tabs>
            <b-tab :title="$gettext('Costs')">
                <import-data-for :url="Urls['accounts_download_costs_upload_sample']()"
                    typeDesc="cost items from past periods" type="costs" />
            </b-tab>
            <b-tab :title="$gettext('Customers')">
                <import-data-for :url="Urls['accounts_download_customer_upload_sample']()" typeDesc="customer information"
                    type="customers"
                    v-bind:note="$gettext('You can also upload the Moneybird sample file that you can download from a Moneybird account. Just select &quot;Moneybird&quot; as a source below, and ensure that the file is a CSV file.')"
                    v-bind:hasDropdown="true"
                    v-bind:sources="[{ value: 'gekko', text: $gettext('Gekko') }, { value: 'moneybird', text: $gettext('Moneybird') }]" />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import ImportDataFor from "@/components/import_data/ImportDataFor";
// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";
export default {
    name: "ImportData",
    components: { ImportDataFor },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Import your data"),
                showCompanyPicker: true
            },
        }
    }
}
</script>
<style></style>